import React, { useEffect, ReactElement } from 'react';

const FormFieldAdapter: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    onChange,
    input,
    meta,
    children,
  } = props;

  const {
    active,
  } = meta;

  const {
    value,
  } = input;

  useEffect((): void => {
    if (onChange && active) {
      onChange(value);
    }
  }, [value]);

  return children;
});

export default FormFieldAdapter;
